import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import { createHarvestYear } from "../../../modules/harvestYearManagement/action";
import Button from "../../FormElement/Button";
import InputFiled from "../../FormElement/InputFiled";



class HarvestYearManagemnet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubFarmId: "",
      harvestYearInfo: {
        farmId: userFarmDetail().id || props.MainFarmId,
        harvestYear: parseInt(harvestYearDetail().name) + 1,
        currentHarvestYear: harvestYearDetail().name,
        selectedHarvestYear: harvestYearDetail().name
      },
      successMessage: ""
    };
  }

  componentDidMount() {
    localStorage.setItem("farmSwitch", false);
  }
  componentWillMount() {
    this.showLastHarvestYear();
  }
  handleChange = event => {
    const { name, type } = event.target;
    const { HarvestYearList } = this.props;
    let { value } = event.target;
    if (name === "harvestYear") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.setState({ harvestYear: value });
      }
      this.setState(prevState => {
        return {
          harvestYearInfo: {
            ...prevState.harvestYearInfo,
            harvestYear: value
          }
        };
      });
    }
    if (name === "harvestYearList") {
      let cYear = HarvestYearList.filter(item => item.harvestYear === value);
      cYear = cYear[0].harvestYear;
      this.setState(prevState => {
        return {
          harvestYearInfo: {
            ...prevState.harvestYearInfo,
            selectedHarvestYear: value,
            currentHarvestYear: cYear,
            harvestYear: cYear + 1
          }
        };
      });
    }
  };

  handleHarvestYear = () => {
    const { harvestYear, harvestYearInfo } = this.state;
    const { HarvestYearList } = this.props;
    // harvestYearInfo.farmId = userFarmDetail().id;
    delete harvestYearInfo.selectedHarvestYear;
    this.props.actions.createHarvestYear(harvestYearInfo).then(data => {
      if (data) {
        this.setState({ successMessage: true });
      }
    });
  };
  showHarvestYearList = HarvestYearList => {
    let harvestYearListArr = [];
    harvestYearListArr = HarvestYearList.map(data => {
      return {
        id: data.id,
        name: data.harvestYear
      };
    });

    return harvestYearListArr;
  };

  showLastHarvestYear = () => {
    const { HarvestYearList } = this.props;
    // let HarvestYearListReverse = HarvestYearList.reverse()
    const lastYear = HarvestYearList[0].harvestYear;
    this.setState(prevState => {
      return {
        harvestYearInfo: {
          ...prevState.harvestYearInfo,
          selectedHarvestYear: lastYear,
          currentHarvestYear: lastYear,
          harvestYear: parseInt(lastYear) + 1
        }
      };
    });
  };
  render() {
    const { harvestYearInfo, successMessage } = this.state;
    const { HarvestYearList = [] } = this.props;
    if (successMessage) {
      return <Redirect to="/farmsetup/" />;
    }
    return (
      <div className="ticket-body" style={{ margin: "1.5em auto" }}>
        <h3 class="mainHeading">Harvest Year Management</h3>
        <div className="innermainform">
          <Grid container spacing={8}>
            <Grid item sm={6} xs={12}>
              <InputFiled
                disabled
                value={harvestYearInfo.selectedHarvestYear}
                label="Roll over from"
                type="text"
                name="harvestYear"
                validations={["onlyNumber"]}
                handleChange={this.handleChange}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <InputFiled
                disabled
                value={harvestYearInfo.harvestYear}
                label="Roll over to"
                type="text"
                name="harvestYear"
                validations={["onlyNumber"]}
                handleChange={this.handleChange}
              />
            </Grid>
            {/* <Grid item xs={12} implementation="css" smDown component={Hidden} /> */}

            <Grid item xs={12}>
              <Button
                style={{ display: "flex", alignSelf: "right" }}
                name="Create New Harvest Year"
                onclick={this.handleHarvestYear}
                disabled={false}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    HarvestYearList: state.harvestYearReducer.HarvestYearList,
    selectedYear: state.harvestYearReducer.selectedYear,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createHarvestYear
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HarvestYearManagemnet);



// WEBPACK FOOTER //
// ./src/components/private/HarvestYear/HarvestYearManagement.js